import { Typography } from '@mui/material';
import Stack from '@mui/material/Stack';



function LegendRateElement({ color, text }) {
    return (
        <Stack
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
        >
            <div style={{ width: "20px", height: "15px", backgroundColor: color, opacity: 0.7, paddingBottom: "1px" }} />
            <Typography
                style={{
                    fontFamily: 'Open Sans, sans-serif',
                    fontSize: "14px",
                }}>{text}</Typography>
        </Stack >
    );
}

export default LegendRateElement;


